<template>
  <div>
    <div>
      <div class="search-bar">
        <!-- <img src="@/assets/img/job-seeker/jam_search.svg" class="search-icon" height="20" alt="Search" /> -->
        <el-input data-testid="directions-35" v-model="filter.text" class="job-board__search" placeholder="Enter Job Title"
          clearable @input="debouncedUpdateLocalStorage" @clear="clearText">
          <template #prefix>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
                stroke="#484848" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M22 22L20 20" stroke="#484848" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </template>
        </el-input>
        <button class="filter-button" data-testid="directions-36" @click="toggleFilterOptions">
          <!-- <img v-if="isFilterOptionsVisible" src="@/assets/img/job-seeker/setting-active.svg" /> -->
          <img src="@/assets/img/job-seeker/setting-inactive.svg" />
          <span v-if="countFilters() > 0">{{ countFilters() }}</span>
        </button>
      </div>

    </div>
    <div v-if="initialIsLoading">
      <job-listing-skeleton :skeletonCount="7" />
    </div>
    <div v-else>
      <div v-if="jobs.length > 0">
        <div v-for="job in jobs" :key="job.id">
          <PreviousJobCard :job="job" />
          <div v-if="isLoading" class="loading-animation">
            <ion-spinner name="dots"></ion-spinner>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="search_jobs_header no-results-job-listing">
          <img :src="require(`@/assets/img/illustrations/no-result.svg`)" alt="" />
          <div class="main_title">No Previous Jobs!</div>
          <div class="main_text">
            No previous jobs were found!
          </div>
        </div>
        <p class="no-results"></p>
      </div>
    </div>

  </div>
  <div id="bottomJobPreviousObserver"></div>

  <el-drawer title="Job Filters" v-model="modalPreviousApplicationVisible" :close-on-click-modal="true"
        :destroy-on-close="true" @close="closeCreateWishlistModal" :append-to-body="true" :direction="'btt'">
        <Filter :modalPreviousApplicationVisible="modalPreviousApplicationVisible" @job-previous-application-filter="updateJobsWithFilters"
            @update:modalPreviousApplicationVisible="updateModalVisibility" />
    </el-drawer>
</template>
  
  <script>
  import PreviousJobCard from './Cards/PreviousJobCard.vue';
  import { useStore } from "vuex";
  // import {
  //   useRouter,
  // } from "vue-router";
  import { onMounted, ref, inject, watchEffect, watch } from 'vue';
  import { addIcons } from 'ionicons';
  import { arrowBackOutline } from 'ionicons/icons';
  import { IonSpinner } from '@ionic/vue';
  import JobListingSkeleton from "@/components/JobListingSkeleton/JobListingSkeleton.vue";
  import Filter from "./Filters/PreviousFilterPage.vue"
  import debounce from 'lodash/debounce';
  addIcons({
    'arrow-back-outline': arrowBackOutline,
  });
  
  
  export default {
    components: {
        PreviousJobCard,
        IonSpinner,
        JobListingSkeleton,
        Filter
    },
    props: {
      isActive: {
        type: Boolean,
        required: true
      }
    },
    setup(props) {
      const $store = useStore();
      // const $router = useRouter();
      const setPageClassGlobal = inject('setPageClassGlobal');
      const jobs = ref([]);
      const currentPage = ref(1); // Track the current page
      const isLoading = ref(false); // Track if data is currently being loaded
      const tabJobPosterPreviousListClicked = ref(false);
      const initialIsLoading = ref(false);
      const modalPreviousApplicationVisible = ref(false);
      const filter = ref(JSON.parse(localStorage.getItem('jobPosterPreviousFilterObject')) ? JSON.parse(localStorage.getItem('jobPosterPreviousFilterObject')) : {
        text: '',
        jobType: '',
        jobLocation: '',
        taggedSkills: [],
      });

      const countFilters = () => {
      let count = 0;
      for (const key in filter.value) {
        const value = filter.value[key];
        if (value != null && value !== '' && !(Array.isArray(value) && value.length === 0)) {
          if (typeof value === 'object' && Object.keys(value).length === 0) {
            continue; // Skip empty objects
          }
          if (key === 'rate' && value.type === '') {
            continue; // Skip empty rate object
          }
          count++;
        }
      }
      // Adjust count if text, jobType, and jobLocation are all empty
      // if (filter.value.text === '' && filter.value.jobType === '' && filter.value.jobLocation === '') {
      //   count--;
      // }
      return count;
    };

  
      const handleIntersection = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadMoreJobs();
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      root: null,
      rootMargin: '500px 0px', // Adjust rootMargin for early loading
      threshold: 0.1, // Trigger when 10% of the element is visible
    });

    
    watchEffect(() => {
      if (props.isActive && tabJobPosterPreviousListClicked.value === false) {
        // Run your initial fetch job data function
        initialFetchJobData();

        // Update tabJobPosterPreviousListClicked to true so that watchEffect doesn't run again
        tabJobPosterPreviousListClicked.value = true;
      }
    });

     // Reset tabJobPosterPreviousListClicked when isActive changes to false
     watchEffect(() => {
      if (!props.isActive) {
        tabJobPosterPreviousListClicked.value = false;
      }
    });
  
      const initialFetchJobData = async () => {
        return new Promise((resolve) => {
          initialIsLoading.value = true;
          $store.dispatch("JOB_POSTER_PREVIOUS_JOB_LIST", { page: currentPage.value, filter: filter.value })
            .then((response) => {
              let jobFetchResult = response.data;
              console.log("🚀 ~ .then ~ jobFetchResult:", jobFetchResult)
              const jobsData = jobFetchResult.map(job => ({
                id: job.id,
                title: job.title,
                location: job.location,
                category: job.category,
                type: job.type,
                description: job.description,
                shortDescription: job.shortDescription,
                jobStatus: job.jobStatus,
                platformRoleName: job.platformRoleName,
                applicants: job.applicants,
                federalPharmacistSupport:job.federalPharmacistSupport ? job.federalPharmacistSupport : null,
              }));
  
              // Assign the mapped data to the jobs ref variable
              jobs.value = jobsData;
              jobs.value.meta = response.meta;
              initialIsLoading.value = false;
              resolve(response);
            });
        });
      };
      const loadMoreJobs = async () => {
        // Prevent loading more data if already loading or if reached last page
        console.log("🚀 ~ loadMoreJobs ~ isLoading:", jobs.value)
        if (isLoading.value || currentPage.value >= jobs.value.meta?.lastPage) return;
        console.log("🚀 ~ loadMoreJobs ~ currentPage:", currentPage)
        isLoading.value = true;
        try {
          const response = await $store.dispatch("JOB_POSTER_PREVIOUS_JOB_LIST", { page: currentPage.value + 1, filter: filter.value });
          const newJobs = response.data.map(job => ({
            id: job.id,
                title: job.title,
                location: job.location,
                category: job.category,
                type: job.type,
                description: job.description,
                shortDescription: job.shortDescription,
                jobStatus: job.jobStatus,
                platformRoleName: job.platformRoleName,
                applicants: job.applicants,
          }));
          jobs.value = [...jobs.value, ...newJobs];
          jobs.value.meta = response.meta;
          currentPage.value++;
        } catch (error) {
          console.error("Error loading more jobs:", error);
        } finally {
          isLoading.value = false;
        }
  
      };
  
  
      const clearText = () => {
        console.log('clear text')
        filter.value.text = '';
        currentPage.value = 1;
        debouncedUpdateLocalStorage();
        // Update local storage to remove only the 'text' property from 'jobPosterPreviousFilterObject'
        const storedValues = JSON.parse(localStorage.getItem('jobPosterPreviousFilterObject'));
        if (storedValues) {
          delete storedValues.text;
          localStorage.setItem('jobPosterPreviousFilterObject', JSON.stringify(storedValues));
        }
        initialFetchJobData();
      };
  
      const toggleFilterOptions = () => {
        modalPreviousApplicationVisible.value = true;
        // $router.push({
        //   name: "job_poster_previous_filter",// Assuming job object has an 'id' property
        // });
      };
      const updateModalVisibility = (value) => {
        modalPreviousApplicationVisible.value = value;
        };

      const updateJobsWithFilters = () => {
        filter.value = JSON.parse(localStorage.getItem('jobPosterPreviousFilterObject')) ? JSON.parse(localStorage.getItem('jobPosterPreviousFilterObject')) : {
          text: '',
          jobType: '',
          jobLocation: '',
          taggedSkills: [],
        };
        loadMoreJobs();
      }

      // Function to update localStorage
      const updateLocalStorage = () => {
        console.log("🚀 ~ updateLocalStorage ~ selectedValues.value", filter.value)
        localStorage.setItem('jobPosterPreviousFilterObject', JSON.stringify(filter.value));
        currentPage.value = 1;
        initialFetchJobData();
      };
      const debouncedUpdateLocalStorage = debounce(updateLocalStorage, 500); // Adjust the debounce delay as needed
      // Watch for changes in filter and update localStorage accordingly
      watch(filter, () => {
        updateLocalStorage();
  
      });
  
      onMounted(() => {
      setPageClassGlobal('global_job_poster_previous_page');
      observer.observe(document.getElementById('bottomJobPreviousObserver'));
    });

  
      return {
        jobs,
        isLoading,
        filter,
        toggleFilterOptions,
        updateLocalStorage,
        clearText,
        countFilters,
        debouncedUpdateLocalStorage,
        initialIsLoading,
        modalPreviousApplicationVisible,
        updateJobsWithFilters,
        updateModalVisibility
      };
    }
  };
  </script>
  